import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIllustrationLocalErrorLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 320 320",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M279.635 93.7224C279.906 93.0262 280.055 92.3368 280.09 91.66V91.0308C279.756 84.6021 269.243 79.5167 257.642 81.025L54.2742 107.464C45.2236 108.641 39.8857 113.209 39.9024 117.897C39.9118 120.534 41.6154 123.209 45.3055 125.34L202.879 216.315C213.129 222.233 230.657 219.302 233.841 211.137L279.635 93.7224Z",
			fill: "#E9EBED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M279.635 93.7224L233.841 211.137C230.657 219.302 213.129 222.233 202.879 216.315L45.3055 125.34C41.6154 123.209 39.9118 120.534 39.9024 117.897V165.7C39.9118 168.337 41.6154 171.012 45.3055 173.142L202.879 264.118C213.129 270.036 230.657 267.104 233.841 258.94L279.635 141.525C279.991 140.612 280.135 139.71 280.09 138.833V91.66C280.055 92.3368 279.906 93.0262 279.635 93.7224Z",
			fill: "#E9EBED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M280.09 91.0308C279.756 84.6021 269.243 79.5167 257.642 81.025L54.2742 107.464C45.2236 108.641 39.8857 113.209 39.9024 117.897M280.09 91.0308V91.66M280.09 91.0308C280.1 91.2392 280.1 91.449 280.09 91.66M39.9024 117.897C39.9118 120.534 41.6154 123.209 45.3055 125.34L202.879 216.315C213.129 222.233 230.657 219.302 233.841 211.137L279.635 93.7224C279.906 93.0262 280.055 92.3368 280.09 91.66M39.9024 117.897V165.7C39.9118 168.337 41.6154 171.012 45.3055 173.142L202.879 264.118C213.129 270.036 230.657 267.104 233.841 258.94L279.635 141.525C279.991 140.612 280.135 139.71 280.09 138.833V91.66",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.996 109.965C243.996 111.751 242.981 113.253 240.911 114.43L194.472 141.263C192.401 142.44 189.804 143.049 186.719 143.049C183.593 143.049 180.995 142.441 178.925 141.223C176.854 140.005 175.798 138.543 175.798 136.717C175.798 134.89 176.813 133.429 178.884 132.251L225.323 105.419C227.393 104.241 229.991 103.633 233.076 103.633C236.202 103.673 238.8 104.241 240.87 105.459C242.94 106.677 243.996 108.138 243.996 109.965Z",
			fill: "white",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M166.581 154.659C166.581 156.445 165.566 157.947 163.496 159.125C161.425 160.342 158.827 160.911 155.742 160.911C152.657 160.911 150.018 160.302 147.948 159.125C146.608 158.313 145.675 157.42 145.228 156.405C144.944 155.837 144.822 155.228 144.822 154.619C144.822 152.833 145.837 151.331 147.907 150.153C149.978 148.936 152.535 148.367 155.661 148.367C158.787 148.367 161.344 148.976 163.414 150.153C164.388 150.722 165.119 151.331 165.607 152.021C166.256 152.833 166.54 153.685 166.581 154.659Z",
			fill: "white",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIllustrationLocalErrorLight;
